import React from 'react';
import { useDocumentTitle } from '~src/hooks/useDocumentTitle';
import styles from './index.module.less';

const imgList = [
    "https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/assets/home-rule_title.png",
    "https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/assets/home-rule_content1.png",
    "https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/assets/home-rule_content2.png",
    "https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/assets/home-rule_content3.png",
    "https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/assets/home-rule_content4.png"
];

const IntegralRule= () => {
    useDocumentTitle('积分攻略');
    return <div className={styles.container}>
        {imgList.map((url) => (
            <img src={url} alt="积分攻略" key={url} />
        ))}
    </div>
}
export default IntegralRule